<template>
  <div :class="clsx('app-header-mobile', { 'animations-disabled': !animationEnabled })">
    <div class="app-header-mobile__logo">
      <Logo v-if="displayLogo" />
    </div>
    <div class="app-header-mobile__main-menu">
      <div
        class="app-header-mobile__burger-button-wrapper"
        @click="() => emitMobileMenuToggle(!isMobileMenuOpen)"
      >
        <BurgerButton
          class="app-header-mobile__burger-button"
          :is-open="isMobileMenuOpen"
        />
      </div>
      <AppMainMenu :routes="getMenuItems" />
    </div>
  </div>
</template>

<script>
import clsx from 'clsx';
import Logo from '../logo';
import { BurgerButton } from '@/shared/ui/burger-button';
import { MainMenuItems, PROMO_HEADER_MOBILE_EVENTS } from '@/widgets/promo';
import AppMainMenu from '@/widgets/promo/ui/app-main-menu';

export default {
  props: {
    displayLogo: {
      type: Boolean,
      default: true,
    },
    animationEnabled: {
      type: Boolean,
      default: true,
    },
    isMobileMenuOpen: {
      type: Boolean,
      required: true,
    },
  },
  components: { Logo, BurgerButton, AppMainMenu },
  computed: {
    getMenuItems() {
      return MainMenuItems;
    },
  },
  methods: {
    clsx,
    emitMobileMenuToggle(event) {
      this.$eventBus.$emit(PROMO_HEADER_MOBILE_EVENTS.PROMO_HEADER_MOBILE_MENU_TOGGLE, event);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-header-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: linear-gradient(to bottom, #CADDFC 0px, #CADDFC 50px, rgba(202, 221, 252, 0) 70px);
  margin-bottom: -10px;

  &__logo {
    animation: small-logo-animation 1s linear forwards;
  }

  &__burger-button-wrapper {
    background: linear-gradient(90deg, #F6AB6F 0%, #EB883B 100%);
    border-radius: 16px;
    padding: 10px;
    transition: background 0.3s ease;
    cursor: pointer;

    &:hover {
      background: linear-gradient(90deg, #e59455 0%, #d67020 100%);
    }
  }

  &__burger-button {
    background-color: #FFFFFF !important;
    border-radius: 50% !important;
    padding: 5px !important;
  }
}

::v-deep {
  .burger {
    .line {
      background-color: #EEA23E !important;
      width: calc(100% - 2px) !important;

      &::before,
      &::after {
        background-color: #EEA23E !important;
        width: 100% !important;
      }
    }
  }
}

.animations-disabled,
.animations-disabled * {
  animation: none !important;
  animation-duration: 0s !important;
  animation-delay: 0s !important;
  transition: none !important;
}

.animations-disabled {
  .app-header-mobile__logo {
    transform: translateX(0%);
  }
}

@keyframes small-logo-animation {
  from {
    transform: translateX(45vw);
  }
  to {
    transform: translateX(0%);
  }
}
</style>
